// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-page {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.calendar-container {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 2rem;
}

.calendar-main {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.calendar-wrapper {
  background: var(--white);
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.react-calendar {
  width: 100%;
  border: none;
  font-family: inherit;
  background: transparent;
}

.react-calendar__navigation {
  margin-bottom: 1rem;
  height: 60px;
}

.react-calendar__navigation button {
  color: var(--dark-gray);
  font-size: 1.1rem;
  font-weight: 600;
  background: transparent;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.react-calendar__navigation button:hover {
  background: var(--light-gray);
}

.react-calendar__navigation button:disabled {
  background: transparent;
}

.react-calendar__month-view__weekdays {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--medium-gray);
}

.react-calendar__tile {
  padding: 1rem;
  background: transparent;
  position: relative;
  transition: all 0.3s ease;
  border-radius: 0.5rem;
}

.react-calendar__tile:hover {
  background: var(--light-gray);
}

.react-calendar__tile--active {
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  color: var(--white);
}

.react-calendar__tile--now {
  background: rgba(37, 99, 235, 0.1);
  color: var(--primary-blue);
  font-weight: 600;
}

.calendar-tile-events {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 2px;
}

.calendar-tile-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.event-form-container {
  background: var(--white);
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.event-form-container h3 {
  font-size: 1.5rem;
  color: var(--dark-gray);
  margin-bottom: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.calendar-sidebar {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.selected-date-info {
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  color: var(--white);
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
}

.selected-date-info h2 {
  font-size: 1.5rem;
  margin: 0;
  text-transform: capitalize;
}

.day-events {
  background: var(--white);
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.day-events h3 {
  font-size: 1.25rem;
  color: var(--dark-gray);
  margin-bottom: 1rem;
}

.no-events {
  text-align: center;
  padding: 2rem;
  color: var(--medium-gray);
}

.no-events-icon {
  font-size: 3rem;
  margin-bottom: 0.5rem;
  opacity: 0.5;
}

.events-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.event-card {
  background: var(--background);
  padding: 1rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.event-card h4 {
  font-size: 1.1rem;
  color: var(--dark-gray);
  margin-bottom: 0.5rem;
}

.event-details {
  display: flex;
  gap: 1rem;
  font-size: 0.875rem;
  color: var(--medium-gray);
  margin-bottom: 0.5rem;
}

.event-details span {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.event-description {
  font-size: 0.875rem;
  color: var(--medium-gray);
  line-height: 1.4;
}

.upcoming-events {
  background: var(--white);
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.upcoming-events h3 {
  font-size: 1.25rem;
  color: var(--dark-gray);
  margin-bottom: 1rem;
}

.upcoming-event-item {
  display: flex;
  gap: 1rem;
  padding: 0.75rem;
  background: var(--background);
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.upcoming-event-item:hover {
  background: var(--light-gray);
  transform: translateX(5px);
}

.event-date-badge {
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  color: var(--white);
  padding: 0.5rem;
  border-radius: 0.5rem;
  min-width: 50px;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.event-date-badge .day {
  font-size: 1.25rem;
  font-weight: 700;
}

.event-date-badge .month {
  font-size: 0.75rem;
  text-transform: uppercase;
}

.event-info h5 {
  font-size: 1rem;
  color: var(--dark-gray);
  margin-bottom: 0.25rem;
}

.event-time {
  font-size: 0.875rem;
  color: var(--medium-gray);
}`, "",{"version":3,"sources":["webpack://./src/pages/Calendar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+EAA+E;EAC/E,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+EAA+E;EAC/E,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,+EAA+E;EAC/E,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".calendar-page {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.calendar-container {\n  display: grid;\n  grid-template-columns: 1fr 400px;\n  gap: 2rem;\n}\n\n.calendar-main {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.calendar-wrapper {\n  background: var(--white);\n  border-radius: 1rem;\n  padding: 2rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n}\n\n.react-calendar {\n  width: 100%;\n  border: none;\n  font-family: inherit;\n  background: transparent;\n}\n\n.react-calendar__navigation {\n  margin-bottom: 1rem;\n  height: 60px;\n}\n\n.react-calendar__navigation button {\n  color: var(--dark-gray);\n  font-size: 1.1rem;\n  font-weight: 600;\n  background: transparent;\n  border-radius: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.react-calendar__navigation button:hover {\n  background: var(--light-gray);\n}\n\n.react-calendar__navigation button:disabled {\n  background: transparent;\n}\n\n.react-calendar__month-view__weekdays {\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: var(--medium-gray);\n}\n\n.react-calendar__tile {\n  padding: 1rem;\n  background: transparent;\n  position: relative;\n  transition: all 0.3s ease;\n  border-radius: 0.5rem;\n}\n\n.react-calendar__tile:hover {\n  background: var(--light-gray);\n}\n\n.react-calendar__tile--active {\n  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));\n  color: var(--white);\n}\n\n.react-calendar__tile--now {\n  background: rgba(37, 99, 235, 0.1);\n  color: var(--primary-blue);\n  font-weight: 600;\n}\n\n.calendar-tile-events {\n  position: absolute;\n  bottom: 4px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 2px;\n}\n\n.calendar-tile-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.event-form-container {\n  background: var(--white);\n  border-radius: 1rem;\n  padding: 2rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n}\n\n.event-form-container h3 {\n  font-size: 1.5rem;\n  color: var(--dark-gray);\n  margin-bottom: 1.5rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.calendar-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.selected-date-info {\n  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));\n  color: var(--white);\n  padding: 2rem;\n  border-radius: 1rem;\n  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);\n}\n\n.selected-date-info h2 {\n  font-size: 1.5rem;\n  margin: 0;\n  text-transform: capitalize;\n}\n\n.day-events {\n  background: var(--white);\n  border-radius: 1rem;\n  padding: 1.5rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n}\n\n.day-events h3 {\n  font-size: 1.25rem;\n  color: var(--dark-gray);\n  margin-bottom: 1rem;\n}\n\n.no-events {\n  text-align: center;\n  padding: 2rem;\n  color: var(--medium-gray);\n}\n\n.no-events-icon {\n  font-size: 3rem;\n  margin-bottom: 0.5rem;\n  opacity: 0.5;\n}\n\n.events-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.event-card {\n  background: var(--background);\n  padding: 1rem;\n  border-radius: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.event-card h4 {\n  font-size: 1.1rem;\n  color: var(--dark-gray);\n  margin-bottom: 0.5rem;\n}\n\n.event-details {\n  display: flex;\n  gap: 1rem;\n  font-size: 0.875rem;\n  color: var(--medium-gray);\n  margin-bottom: 0.5rem;\n}\n\n.event-details span {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.event-description {\n  font-size: 0.875rem;\n  color: var(--medium-gray);\n  line-height: 1.4;\n}\n\n.upcoming-events {\n  background: var(--white);\n  border-radius: 1rem;\n  padding: 1.5rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n}\n\n.upcoming-events h3 {\n  font-size: 1.25rem;\n  color: var(--dark-gray);\n  margin-bottom: 1rem;\n}\n\n.upcoming-event-item {\n  display: flex;\n  gap: 1rem;\n  padding: 0.75rem;\n  background: var(--background);\n  border-radius: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.upcoming-event-item:hover {\n  background: var(--light-gray);\n  transform: translateX(5px);\n}\n\n.event-date-badge {\n  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));\n  color: var(--white);\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  min-width: 50px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n}\n\n.event-date-badge .day {\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n\n.event-date-badge .month {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n}\n\n.event-info h5 {\n  font-size: 1rem;\n  color: var(--dark-gray);\n  margin-bottom: 0.25rem;\n}\n\n.event-time {\n  font-size: 0.875rem;\n  color: var(--medium-gray);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
